/**
 * 文件上传 API 路径
 */
export const FILE_UPLOAD_API_PATHS = {
    /** 单文件上传 */
    SINGLE_UPLOAD: '/file-upload/single',
    /** 批量文件上传 */
    BATCH_UPLOAD: '/file-upload/batch',
    /** 获取文件下载链接 */
    DOWNLOAD_URL: '/file-upload/download-url',
    /** 删除文件 */
    DELETE: '/file-upload/delete',
    /** 检查文件是否存在 */
    EXISTS: '/file-upload/exists',
    /** 获取文件元数据 */
    METADATA: '/file-upload/metadata',
} as const;

/**
 * 默认文件夹路径
 */
export const DEFAULT_FILE_FOLDER_PATH = 'general/files';

/**
 * 默认文件名前缀
 */
export const DEFAULT_FILE_PREFIX = 'file';

/**
 * 默认单文件最大大小（MB）
 */
export const DEFAULT_MAX_FILE_SIZE_MB = 10;

/**
 * 默认下载链接有效期（分钟）
 */
export const DEFAULT_DOWNLOAD_EXPIRE_MINUTES = 60;
